
import { Link } from 'react-router-dom';
import S from './style'
import TranslateStatic from '../../locales/TranslateStatic';
import { LocaleContext } from '../../locale-context';
import IMG from '../../assets/ekip/adil.png'
export function Adil() {
  return (
    <S.PageWrapper>
      <S.HeroSection>
        <div className="hero-content">
          <h1>Prof. Dr. Adil Gökalp</h1>
          <S.Breadcrumb>
            <Link to="/"><TranslateStatic string="home" /></Link>
            <span className="separator">/</span>
            <TranslateStatic string="teamHeader" />
          </S.Breadcrumb>
        </div>
      </S.HeroSection>

      <S.ContentWrapper>
        <div className="profile-card">
          <div className="profile-sidebar">
            <div className="avatar-wrapper">
              <img src={IMG} alt="Prof. Dr. Adil Gökalp" />
            </div>
            <h2>Prof. Dr. Adil Gökalp</h2>
            <div className="tags">
              <span className="badge primary"><TranslateStatic string="Adil" /></span>
            </div>
          </div>
          <div className="profile-body">
            <div className="cv-body">
        <LocaleContext.Consumer>
          {(value) => {
            if (value === "tr") {
              return <div>
                <h3>Kişisel Bilgiler</h3>

                <p>Dr Adil Gökalp 1960 yılında Lüleburgaz’da dogdu.
                  1983 tarihinde Akdeniz Üniversitesi Tıp Fakültesinden mezun oldu. Aynı yıl teğmen rütbesi ile Türk Silahlı Kuvvetlerinde göreve başladı.
                  1987 - 1992 tarihleri arasında GATA'da üroloji Uzmanı olarak görev yaptı.2001 yılında doçent, 2010 yılında Profesör oldu.
                </p>
                <p>2003 yılında Türk Silahlı Kuvvetlerinden albay rütbesiyle emekli oldu.</p>
                <p>12 yıldır Gelecek Tüp Bebek Merkezinde Üroloji Uzmanı olarak görev yapmaktadır.</p>

              </div>

            } else if (value === 'en') {
              return <div>
                <h3>Personal Information</h3>

                <p>Dr Adil Gökalp was born in Lüleburgaz in 1960.
                  He graduated from Akdeniz University Faculty of Medicine in 1983. In the same year, he started working in the Turkish Armed Forces with the rank of lieutenant.
                  He worked as a urology specialist at GATA between 1987 and 1992. He became an associate professor in 2001 and a professor in 2010.
                </p>
                <p>He retired from the Turkish Armed Forces in 2003 with the rank of colonel.</p>
                <p>He has been working as a Urology Specialist at the Future In Vitro Fertilization Center for 12 years.</p>

              </div>
            }
            else if (value === 'ru') {
              return <div>
                <h3>Личные данные</h3>

                <p>Доктор Адиль Гёкальп родился в 1960 году в Люлебургазе.
                  В 1983 году окончил медицинский факультет Университета Акдениз. В том же году начал службу в Турецких вооруженных силах в звании лейтенанта.
                  В период с 1987 по 1992 год работал урологом в GATA. В 2001 году стал доцентом, в 2010 году - профессором.
                </p>
                <p>В 2003 году вышел в отставку из Турецких вооруженных сил в звании полковника.</p>
                <p>12 лет работает в Геле</p>

              </div>
            }
            else if (value === 'ar') {
              return <div>
                <h3>المعلومات الشخصية</h3>

                <p>الدكتور عديل جوكالب وُلِد عام 1960 في لولبورغاز.
                  تخرج من كلية الطب بجامعة أكدنيز عام 1983. في نفس العام بدأ خدمته في القوات المسلحة التركية برتبة ملازم.
                  في الفترة ما بين 1987-1992 عمل كأخصائي مسالك بولية في مستشفى GATA. أصبح أستاذًا مساعدًا عام 2001، ثم حصل على درجة الأستاذية عام 2010.
                </p>
                <p>تقاعد من القوات المسلحة التركية عام 2003 برتبة عقيد.</p>
                <p>يعمل منذ 12 عامًا في جي</p>

              </div>
            }
            else if (value === 'uz') {
              return <div>
                <h3>Shaxsiy Ma'lumotlar</h3>

                <p>Doktor Adil Gökalp 1960 yilda Lüleburgaz shahrida tug'ilgan.
                  1983 yilda Akdeniz Universiteti Tibbiyot Fakultetini tamomlagan. O'sha yili leytenant unvoni bilan Turkiya Qurolli Kuchlarida xizmatni boshlagan.
                  1987-1992 yillari oralig'ida GATA da urolog mutaxassisi sifatida ishlagan. 2001 yilda dotsent, 2010 yilda professor ilmiy darajasini olgan.
                </p>
                <p>2003 yilda Turkiya Qurolli Kuchlaridan polkovnik unvoni bilan nafaqaga chiqqan.</p>
                <p>12 yildan beri Gel...</p>

              </div>
            }
          }}
        </LocaleContext.Consumer>

            </div>
          </div>
        </div>
      </S.ContentWrapper>
    </S.PageWrapper>
  );
}
